import { render } from "./EditRoute.vue?vue&type=template&id=611645da"
import script from "./EditRoute.vue?vue&type=script&lang=js"
export * from "./EditRoute.vue?vue&type=script&lang=js"
script.render = render

export default script